import "./LanguageSwitcher.scss";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

interface LanguageSwitcherProps {
  mobile?: boolean;
  toggleNavbar?: () => void;
}

const LanguageSwitcher = ({
  mobile = false,
  toggleNavbar,
}: LanguageSwitcherProps) => {
  const { t } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();

  const currentLanguage = useMemo(() => {
    return lang === "fr" ? "fr" : "en";
  }, [lang]);

  const setLanguage = (newLang: "en" | "fr") => {
    if (currentLanguage === newLang) return;
    navigate(`/${newLang}/`);

    if (mobile && toggleNavbar) {
      toggleNavbar();
    }
  };

  return (
    <div
      className={`languageSwitcher ${mobile ? "mobile" : ""}`}
      role="group"
      aria-label={t("language.switcher_aria")}
    >
      <button
        type="button"
        className={currentLanguage === "en" ? "active" : ""}
        onClick={() => setLanguage("en")}
      >
        EN
      </button>
      <button
        type="button"
        className={currentLanguage === "fr" ? "active" : ""}
        onClick={() => setLanguage("fr")}
      >
        FR
      </button>
    </div>
  );
};

export default LanguageSwitcher;
